import { useDispatch, useSelector } from 'react-redux';
import { PageAlert as BeamPageAlert, Surface } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { PageAlert } from '@app/components/Alerts/PageAlert';
import AlertSectionLayout from '@app/components/AlertSectionLayout';
import { Alert } from '@app/redux/alerts';
import { resetUpdateStatus, selectUserInfo } from '@app/redux/userInfo';
import { checkAlertDismissed } from '@app/utils';

const ProfileAlerts = ({ alerts }: { alerts: Alert[] }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['Profile', 'Common']);

  const { wasUpdateSuccessful, error } = useSelector(selectUserInfo);

  const profileAlerts = alerts.length > 0 ? alerts.filter((alert) => !checkAlertDismissed(alert.type)) : [];

  return (
    <AlertSectionLayout>
      {wasUpdateSuccessful && (
        <BeamPageAlert
          data-cy="contact-info-update-success"
          key="contact-info-update-success"
          title={t('Common:Success')}
          variant="success"
          description={t('Profile:contactUpdateSuccess')}
          closeable={true}
          onClose={() => dispatch(resetUpdateStatus())}
        />
      )}

      {error && (
        <BeamPageAlert
          data-cy="contact-info-update-error"
          key="contact-info-update-error"
          title={t('Common:Error')}
          variant="error"
          description={t('Profile:contactUpdateError')}
          closeable={true}
          onClose={() => dispatch(resetUpdateStatus())}
        />
      )}

      {profileAlerts.length > 0 && (
        <Surface variant="secondary">
          {profileAlerts.map((alert) => (
            <PageAlert key={alert.title} alert={alert} />
          ))}
        </Surface>
      )}
    </AlertSectionLayout>
  );
};
export default ProfileAlerts;
